import Icon from '../components/Icon.vue'

Icon.register({
  tablets: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M160 192C78.9 192 12.5 250.5 0.1 326.7-0.7 331.5 3.4 336 8.4 336H311.7C316.7 336 320.8 331.5 320 326.7 307.5 250.5 241.1 192 160 192zM311.6 368H8.4C3.4 368-0.7 372.5 0.1 377.3 12.5 453.5 78.9 512 160 512S307.5 453.5 319.9 377.3C320.7 372.5 316.6 368 311.6 368zM593.4 46.6C536.9-9.9 449.2-14.8 386.5 30.6 382.5 33.5 382.2 39.5 385.7 42.9L597 254.3C600.5 257.8 606.5 257.5 609.3 253.5 654.8 190.8 649.9 103.1 593.4 46.6zM363 65.7C359.5 62.2 353.5 62.5 350.7 66.5 305.3 129.2 310.2 216.9 366.6 273.4 423.1 329.9 510.8 334.8 573.5 289.3 577.5 286.4 577.8 280.4 574.3 277L363 65.7z'
      }
    ]
  }
})
